import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import API from '@/services/api'
import Highcharts from 'highcharts'
import HighchartsMore from 'highcharts/highcharts-more'
import SolidGauge from 'highcharts/modules/solid-gauge'
import Exporting from 'highcharts/modules/exporting'
import OfflineExporting from 'highcharts/modules/offline-exporting'
import moment from 'moment'

HighchartsMore(Highcharts)
SolidGauge(Highcharts)
Exporting(Highcharts)
OfflineExporting(Highcharts)

export const printEvaluationPDF = async (
    questionsForm,
    form,
    supplier,
    open = true
) => {
    try {
        const {
            data: { settings },
        } = await API.getSettings()
        let company = settings.find(s => s.name == 'Company').generalInfo
        const pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: [215.9, 279.4],
        })
        let aspectRatio = await getAspectRatio(company.logoBase64)
        const header = function(data) {
            // Calculate available space to avoid overlapping with table content
            const pageWidth = pdf.internal.pageSize.width
            const marginLeft = data.settings.margin.left
            const totalWidth = pageWidth - 20
            const firstColumnWidth = totalWidth * 0.2 // First column is 20% of total width
            const tableContentStartX = marginLeft + firstColumnWidth // Where table content (col 1) starts
            const logoStartX = marginLeft + 5
            const minGap = 5 // Minimum gap between logo and table content
            const maxLogoWidth = tableContentStartX - logoStartX - minGap

            const maxImgHeight = 15
            let imgHeight = maxImgHeight
            let imgWidth = imgHeight * aspectRatio

            // If width exceeds available space, scale down proportionally
            if (imgWidth > maxLogoWidth) {
                imgWidth = maxLogoWidth
                imgHeight = imgWidth / aspectRatio
            }

            const imgX = logoStartX
            const imgY = 15
            pdf.addImage(
                company.logoBase64,
                'PNG',
                imgX,
                imgY,
                imgWidth,
                imgHeight
            )
        }
        const totalWidth = pdf.internal.pageSize.width - 20

        let descriptionOptions = {
            styles: {
                halign: 'center',
                valign: 'middle',
                cellPadding: 1,
                overflow: 'linebreak',
                fontSize: 8,
                lineColor: [0, 0, 0],
                lineWidth: 0,
                minCellHeight: 4,
            },
            margin: { top: 35, left: 10 },
            headStyles: {
                textColor: [0, 0, 0],
            },
        }

        const fontSize = 5
        pdf.setFontSize(fontSize)

        const tableDataInfo = [
            [
                { content: '', rowSpan: 5 },
                {
                    content: 'EVALUACIÓN DE PROVEEDORES',
                    rowSpan: 5,
                    styles: {
                        fontStyle: 'bold',
                        fontSize: 12,
                        halign: 'center',
                    },
                },
                { content: '', rowSpan: 1 },
                { content: '', rowSpan: 1 },
            ],
            [
                {
                    content: 'CÓDIGO:',
                    rowSpan: 1,
                    styles: {
                        halign: 'left',
                        fontStyle: 'bold',
                    },
                },
                {
                    content: 'F01-PRPS-03',
                    rowSpan: 1,
                    styles: {
                        halign: 'left',
                    },
                },
            ],
            [
                {
                    content: 'FECHA:',
                    rowSpan: 1,
                    styles: {
                        halign: 'left',
                        fontStyle: 'bold',
                    },
                },
                {
                    content: '2025-09-17',
                    rowSpan: 1,
                    styles: {
                        halign: 'left',
                    },
                },
            ],
            [
                {
                    content: 'VERSIÓN:',
                    rowSpan: 1,
                    styles: {
                        halign: 'left',
                        fontStyle: 'bold',
                    },
                },
                {
                    content: '03',
                    rowSpan: 1,
                    styles: {
                        halign: 'left',
                    },
                },
            ],
            [
                {
                    content: 'TIPO:',
                    rowSpan: 1,
                    styles: {
                        halign: 'left',
                        fontStyle: 'bold',
                    },
                },
                {
                    content: 'RESTRINGIDO',
                    rowSpan: 1,
                    styles: {
                        halign: 'left',
                    },
                },
            ],
        ]
        const originalWarn = console.warn
        console.warn = () => {
            return null
        }
        pdf.autoTable({
            body: tableDataInfo,
            startY: 10,
            theme: 'grid',
            ...descriptionOptions,
            didDrawPage: function(data) {
                header(data)
            },
            columnStyles: {
                0: { cellWidth: totalWidth * 0.2 },
                1: { cellWidth: totalWidth * 0.6 },
                2: { cellWidth: totalWidth * 0.08 },
                3: { cellWidth: totalWidth * 0.12 },
            },
        })
        descriptionOptions.startY = pdf.autoTable.previous.finalY
        pdf.setDrawColor(0)
        pdf.setLineWidth(0.2)
        pdf.line(
            10,
            descriptionOptions.startY + 2,
            totalWidth + 10,
            descriptionOptions.startY + 2
        )

        const gaugeBase64 = await generateHighchartsGauge(
            (form.purchasingScore || 0) +
                (form.warehouseScore || 0) +
                (form.sstScore || 0) +
                (form.environmentalScore || 0)
        )
        const pageWidth = pdf.internal.pageSize.getWidth()
        const imgWidth = 100
        const imgHeight = 60
        const imgX = (pageWidth - imgWidth) / 2
        const imgY = descriptionOptions.startY + 10

        pdf.addImage(gaugeBase64, 'PNG', imgX, imgY, imgWidth, imgHeight)
        descriptionOptions.startY = imgY + imgHeight
        descriptionOptions.margin = { top: 0, left: 10 }
        descriptionOptions.styles.lineWidth = 0

        const supplierInfo = [
            [
                {
                    content: 'Proveedor:',
                    styles: {
                        fontStyle: 'bold',
                        halign: 'left',
                    },
                },
                {
                    content: supplier.name ?? '',
                    styles: {
                        halign: 'left',
                    },
                },
                {
                    content: 'Fecha de evaluación:',
                    styles: {
                        fontStyle: 'bold',
                        halign: 'left',
                    },
                },
                {
                    content:
                        (await formatDate(
                            form.date.seconds
                                ? form.date.seconds
                                : form.date._seconds
                        )) ?? '',
                    styles: {
                        halign: 'left',
                    },
                },
                {
                    content: '',
                },
                {
                    content: '',
                },
            ],
            [
                {
                    content: 'NIT:',
                    styles: {
                        fontStyle: 'bold',
                        halign: 'left',
                    },
                },
                {
                    content: supplier.nit ?? '',
                    styles: {
                        halign: 'left',
                    },
                },

                {
                    content: 'Tipo de evaluación:',
                    styles: {
                        fontStyle: 'bold',
                        halign: 'left',
                    },
                },
                {
                    content:
                        form.evaluationType === 'initial'
                            ? 'Inicial'
                            : form.evaluationType === 'reevaluation'
                            ? 'Re-evaluación'
                            : '',
                    styles: {
                        halign: 'left',
                    },
                },
            ],
        ]
        pdf.autoTable({
            body: supplierInfo,
            theme: 'plain',
            tableLineColor: [0, 0, 0],

            ...descriptionOptions,
            columnStyles: {
                0: { cellWidth: totalWidth * 0.09 },
                1: { cellWidth: totalWidth * 0.23 },
                2: { cellWidth: totalWidth * 0.18 },
                3: { cellWidth: totalWidth * 0.18 },
                4: { cellWidth: totalWidth * 0.16 },
                5: { cellWidth: totalWidth * 0.16 },
            },
        })
        descriptionOptions.startY = pdf.autoTable.previous.finalY
        pdf.setDrawColor(0)
        pdf.setLineWidth(0.2)
        pdf.line(
            10,
            descriptionOptions.startY + 2,
            totalWidth + 10,
            descriptionOptions.startY + 2
        )

        descriptionOptions.startY = descriptionOptions.startY + 5

        const questionsGrouped = groupedQuestions(questionsForm)
        for (const [category, group] of Object.entries(questionsGrouped)) {
            const categoryTitle = [
                [
                    {
                        content: category ?? '',
                        styles: {
                            fontStyle: 'bold',
                            halign: 'left',
                            fontSize: 10,
                        },
                    },
                ],
            ]
            pdf.autoTable({
                body: categoryTitle,
                theme: 'plain',
                tableLineColor: [0, 0, 0],

                ...descriptionOptions,
                columnStyles: {
                    0: { cellWidth: totalWidth * 1 },
                },
            })
            descriptionOptions.startY = pdf.autoTable.previous.finalY
            const map = {
                YES: 'SÍ',
                PARTIALLY: 'PARCIALMENTE',
                NO: 'NO',
            }
            for (const question of group) {
                const questionText = [
                    [
                        {
                            content: `• ${question.question ?? ''}`,
                            styles: {
                                halign: 'left',
                                cellPadding: {
                                    left: 2,
                                    top: 0,
                                    right: 0,
                                    bottom: 1,
                                },
                            },
                        },
                        {
                            content: map[form[question.variable]] || 'NO',
                            styles: {
                                halign: 'center',
                                cellPadding: {
                                    left: 0,
                                    top: 0,
                                    right: 0,
                                    bottom: 1,
                                },
                                fontSize: 7,
                            },
                        },
                    ],
                ]
                pdf.autoTable({
                    body: questionText,
                    theme: 'grid',
                    tableLineColor: [0, 0, 0],

                    ...descriptionOptions,
                    columnStyles: {
                        0: { cellWidth: totalWidth * 0.86 },
                        1: { cellWidth: totalWidth * 0.14 },
                    },
                })
                descriptionOptions.startY = pdf.autoTable.previous.finalY
            }
        }
        const allNotes = [
            ...(form.purchasingNotes ? [form.purchasingNotes] : []),
            ...(form.warehouseNotes ? [form.warehouseNotes] : []),
            ...(form.sstNotes ? [form.sstNotes] : []),
            ...(form.environmentalNotes ? [form.environmentalNotes] : []),
        ]

        if (allNotes.length > 0) {
            pdf.addPage()
            descriptionOptions.startY = 10
            const notesTitle = [
                [
                    {
                        content: 'Notas:',
                        styles: {
                            fontStyle: 'bold',
                            halign: 'left',
                            fontSize: 10,
                        },
                    },
                ],
            ]
            pdf.autoTable({
                body: notesTitle,
                theme: 'plain',
                tableLineColor: [0, 0, 0],

                ...descriptionOptions,
                columnStyles: {
                    0: { cellWidth: totalWidth * 1 },
                },
            })
            descriptionOptions.startY = pdf.autoTable.previous.finalY
            for (const note of allNotes) {
                const notes = [
                    [
                        {
                            content: `• ${note}`,
                            styles: {
                                halign: 'left',
                                cellPadding: {
                                    left: 2,
                                    top: 0,
                                    right: 0,
                                    bottom: 1,
                                },
                            },
                        },
                    ],
                ]
                pdf.autoTable({
                    body: notes,
                    theme: 'plain',
                    tableLineColor: [0, 0, 0],

                    ...descriptionOptions,
                    columnStyles: {
                        0: { cellWidth: totalWidth * 1 },
                    },
                })
                descriptionOptions.startY = pdf.autoTable.previous.finalY
            }
        }

        console.warn = originalWarn
        const pdfDataUri = pdf.output('datauristring')
        const blob = dataURItoBlob(pdfDataUri)
        if (open) {
            const blobURL = URL.createObjectURL(blob)
            const printWindow = window.open(blobURL)
            printWindow.onload = function() {
                URL.revokeObjectURL(blobURL)
            }
        }
        return blob
    } catch (error) {
        console.log(error)
    }
}

const getAspectRatio = async file => {
    return new Promise(function(resolved) {
        var i = new Image()
        i.onload = function() {
            resolved(i.width / i.height)
        }
        i.src = file
    })
}

const generateHighchartsGauge = value => {
    return new Promise(resolve => {
        const container = document.createElement('div')
        container.style.display = 'none'
        document.body.appendChild(container)

        const chart = Highcharts.chart(container, {
            chart: {
                type: 'gauge',
                plotBackgroundColor: null,
                plotBackgroundImage: null,
                plotBorderWidth: 0,
                plotShadow: false,
                height: '350',
            },
            title: { text: null },
            subtitle: { text: null },
            exporting: {
                chartOptions: {
                    title: { text: null },
                    subtitle: { text: null },
                },
            },
            credits: { enabled: false },
            pane: {
                startAngle: -90,
                endAngle: 90,
                background: null,
                center: ['50%', '75%'],
                size: '140%',
            },
            yAxis: {
                min: 0,
                max: 100,
                tickInterval: 5,
                tickPixelInterval: 72,
                tickPosition: 'inside',
                tickColor: 'var(--highcharts-background-color, #FFFFFF)',
                tickLength: 40,
                tickWidth: 2,
                minorTickInterval: null,
                labels: {
                    distance: 20,
                    style: {
                        fontSize: '14px',
                        color: '#000000',
                    },
                },
                lineWidth: 0,
                plotBands: [
                    {
                        from: 0,
                        to: 60,
                        color: '#F44336',
                        thickness: 40,
                    },
                    {
                        from: 60,
                        to: 80,
                        color: '#FFEB3B',
                        thickness: 40,
                    },
                    {
                        from: 80,
                        to: 100,
                        color: '#8BC34A',
                        thickness: 40,
                    },
                ],
            },
            series: [
                {
                    data: [value],
                    dial: {
                        radius: '80%',
                        backgroundColor: 'gray',
                        baseWidth: 16,
                        baseLength: '0%',
                        rearLength: '0%',
                    },
                    pivot: { backgroundColor: 'gray', radius: 8 },
                    dataLabels: {
                        format: '{y}',
                        style: { fontSize: '16px' },
                        borderWidth: 0,
                        backgroundColor: 'none',
                    },
                },
            ],
        })

        const svg = chart.getSVG()
        const svgBlob = new Blob([svg], { type: 'image/svg+xml;charset=utf-8' })
        const url = URL.createObjectURL(svgBlob)

        const img = new Image()
        img.onload = () => {
            const canvas = document.createElement('canvas')
            canvas.width = img.width
            canvas.height = img.height
            const ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0)
            const base64 = canvas.toDataURL('image/png')
            chart.destroy()
            document.body.removeChild(container)
            URL.revokeObjectURL(url)
            resolve(base64)
        }
        img.src = url
    })
}
const groupedQuestions = questions => {
    const safeQuestions = Array.isArray(questions) ? questions : []
    return safeQuestions.reduce((groups, q) => {
        if (!groups[q.category]) groups[q.category] = []
        groups[q.category].push(q)
        return groups
    }, {})
}
const formatDate = seconds => {
    return moment.unix(seconds).format('YYYY-MM-DD')
}
const dataURItoBlob = dataURI => {
    const byteString = Uint8Array.from(atob(dataURI.split(',')[1]), c =>
        c.charCodeAt(0)
    )
    const blobType = dataURI
        .split(',')[0]
        .split(':')[1]
        .split(';')[0]
    return new Blob([byteString], { type: blobType })
}
